query MobileCoreLabelAllIssues(
	$offset: Int!
	$limit: Int!
	$sort: mobile_core_label_issuesSort
	$daysFilter: ConditionInt
	$severityFilter: ConditionString
	$issueTypeFilter: ConditionString
	$appIdFilter: ConditionString
	$textSearch: mobile_core_label_issuesSearchInsensitive
	$businessUnitFilter: ConditionString
) {
	mobile_core_label_issues(
		offset: $offset
		limit: $limit
		sort: $sort
		run_time_last_n_days: $daysFilter
		severity_name_eq: $severityFilter
		type_name_eq: $issueTypeFilter
		app_id_eq: $appIdFilter
		text_contains: $textSearch
		business_unit_eq: $businessUnitFilter
		deleted_eq: { value: false }
	) {
		issue_id
		run_id
		product_name
		type_name
		severity_name
		app_id
		session_name
		test_name
		element_description
		element_index
		user_name
	}
	total: mobile_core_label_issues(
		run_time_last_n_days: $daysFilter
		severity_name_eq: $severityFilter
		type_name_eq: $issueTypeFilter
		app_id_eq: $appIdFilter
		text_contains: $textSearch
		business_unit_eq: $businessUnitFilter
		deleted_eq: { value: false }
	) {
		issue_id_count
	}
	unfilteredTotal: mobile_core_label_issues(
		deleted_eq: { value: false }
		business_unit_eq: $businessUnitFilter
	) {
		issue_id_count
	}
}
